import { render } from "./DemarchageTelephonique.vue?vue&type=template&id=4f974822&scoped=true"
import script from "./DemarchageTelephonique.vue?vue&type=script&lang=js"
export * from "./DemarchageTelephonique.vue?vue&type=script&lang=js"

import "./DemarchageTelephonique.vue?vue&type=style&index=0&id=4f974822&scoped=true&lang=css"

import exportComponent from "/builds/fr.swissLife.nxtCms/cms/nxtcms/nxt-front-ui/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f974822"]])

export default __exports__